var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownload(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4487 8.58639L12.5759 7.71364L10.5187 9.7583V1.91602H9.27193V9.7583L7.21473 7.71364L6.34198 8.58639L9.89532 12.1522L13.4487 8.58639Z",
    fill: "#1F36C7"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.7529 10.0195V16.2535H3.03829V10.0195H1.7915V17.5002H17.9997V10.0195H16.7529Z",
    fill: "#1F36C7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownload);
export default __webpack_public_path__ + "static/media/download.9b9fa33acc1443030f1795f28558b1df.svg";
export { ForwardRef as ReactComponent };